const url = 'https://www.wrike.com/form/eyJhY2NvdW50SWQiOjI0Mjk1ODQsInRhc2tGb3JtSWQiOjU5ODc5Nn0JNDc5MTM3MDE0MTA4MglhMTkwYTc3YWIzOGE5ZTkzNmE2ZDRjNTU1MGNhY2ZkMzZiYTFkNjI0MmIwYjllMzViZDUwMGMzMDU4YjdlYjQy';

export default url;
